import { useContext, useEffect, useRef, useState, useCallback } from "react";
import { useRouteMatch } from "react-router-dom";

import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { MenuItem, MenuList } from "@mui/material";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Scroll from 'react-scroll';
import { MobiOrNotContext, OrderContext } from "../../ContextApi/context";
import MyDateTime from "../../DTechComp/MyDateTime";
import ProductItem from "./ProductItem";
import ProductItemDeskTop from "./ProductItemDeskTop";
import BuisRating from "./RestDetails/BuisRating";
import DayOpeningHours from "./RestDetails/DayOpeningHours";
import AddressLine from "./RestDetails/addressLine";
import myFunctions, { getPhoneDisplay } from "../../myFunctions";
import PhoneLink from "../../DTechComp/PhoneLink";
import { set, sub } from "date-fns";
import utilsRests from "../../_Utils/utilsRests";
import ConnUrls from "../../Connections/ConnectURL";

var scroller = Scroll.scroller;

const RestSuperMenu = (props) => {
    let { path, url } = useRouteMatch();
    const [currP] = useState(props.restPage);
    const [order, setOrder] = useContext(OrderContext);
    const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);
    const [value, setValue] = useState(false);
    const [sender, setSender] = useState(null);

    const RestMnuRef = useRef(0);
    const searchBarRef = useRef(null);
    const [restMnuFxClass, setRestMnuFxClass] = useState("noFix");
    //גובה הראש הקבוע (inMast, position:fixed בדסקטופ) - נמדד בפועל ולא
    //קבוע קשיח, כדי שתפריט הקטגוריות ושורת החיפוש ידבקו בדיוק מתחתיו
    //כשהופכים fixed
    const [headerHeight, setHeaderHeight] = useState(0);
    //ברגע ש-BottomMast נכנס לתצוגה, במקום לחזור ל-relative (מה שגורם
    //לאלמנט "לקפוץ" למיקום הסטטי שלו בראש התפריט, רחוק מעיני המשתמש) -
    //עוברים ל-absolute עם top קפוא בדיוק במקום שבו ה-fixed הפסיק, כך
    //שהאלמנט "נעצר" חלק בדיוק מעל BottomMast בלי קפיצה חזותית
    const [frozenTop, setFrozenTop] = useState(null);
    const searchTimeoutRef = useRef(null);
    const [restMnuSpClass, setRestMnuSpClass] = useState("");
    const [subVal, setSubVal] = useState({ Division: -1, SubDivision: -1 });
    const [mnuDivsPadd, setMnuDivsPadd] = useState("noPadd");

    const [searchTxt, setSearchTxt] = useState("");
    const [shHidMoreDetails, setShHidMoreDetails] = useState(false);

    const [onlyPhone, setOnlyPhone] = useState();
    const [selectedCategory, setSelectedCategory] = useState(null); // קטגוריה שנבחרה
    const [selectedSubCategory, setSelectedSubCategory] = useState(null); // תת-קטגוריה שנבחרה
    const [filteredProducts, setFilteredProducts] = useState([]); // מוצרים מסוננים שמוצגים
    const [currentOffset, setCurrentOffset] = useState(0); // האופסט הנוכחי לטעינה
    const currentOffsetRef = useRef(0); // ref לערך העדכני של offset
    const [hasMore, setHasMore] = useState(true); // האם יש עוד מוצרים לטעון
    const [totalProducts, setTotalProducts] = useState(0); // סך כל המוצרים
    const categoryHeaderRefs = useRef({}); // רפרנסים לכותרות הקטגוריות
    const isScrollingProgrammatically = useRef(false); // דגל למניעת עדכון בזמן גלילה פרוגרמטית
    const loadMoreTriggerRef = useRef(null); // רפרנס לאלמנט שמפעיל טעינה נוספת
    const isLoadingMore = useRef(false); // דגל למניעת טעינות כפולות
    const currentLoadingParams = useRef(null); // פרמטרים נוכחיים לטעינה
    const lastScrollY = useRef(0); // מיקום גלילה קודם למעקב אחרי כיוון
    const scrollDirection = useRef('down'); // כיוון הגלילה
    const hasInitialLoaded = useRef(false); // דגל למניעת טעינה ראשונית כפולה


    useEffect(() => {
        window.addEventListener("scroll", handleScroll);

        if (!mobiOrNot) {
            const inMastEl = window.document.getElementsByClassName("inMast")[0];
            if (inMastEl) setHeaderHeight(inMastEl.offsetHeight);
        }

        // מעקב אחרי כיוון הגלילה
        const trackScrollDirection = () => {
            const currentScrollY = window.scrollY;
            if (currentScrollY > lastScrollY.current) {
                scrollDirection.current = 'down';
            } else if (currentScrollY < lastScrollY.current) {
                scrollDirection.current = 'up';
            }
            lastScrollY.current = currentScrollY;
        };

        window.addEventListener("scroll", trackScrollDirection);

        return () => {
            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("scroll", trackScrollDirection);
        };

    }, []);

    // Intersection Observer for category headers
    useEffect(() => {
        // observer אחיד לשני הכיוונים - כותרת במרכז (50%)
        const observerOptions = {
            root: null,
            rootMargin: '-50% 0px -50% 0px', // כותרת במרכז המסך (50%) בשני הכיוונים
            threshold: 0
        };

        const observerCallback = (entries) => {
            if (isScrollingProgrammatically.current) return;

            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const categoryIndex = parseInt(entry.target.dataset.categoryIndex);
                    const subCategoryIndex = parseInt(entry.target.dataset.subCategoryIndex);
                    
                    if (!isNaN(categoryIndex) && categoryIndex >= 0) {
                        setValue(categoryIndex);
                        setSelectedCategory(categoryIndex);
                        
                        if (!isNaN(subCategoryIndex)) {
                            setSelectedSubCategory(subCategoryIndex);
                            setSubVal({ Division: categoryIndex, SubDivision: subCategoryIndex });
                        }
                    }
                }
            });
        };

        const observer = new IntersectionObserver(observerCallback, observerOptions);

        // המתן רגע לפני עקיבה אחרי כותרות (אחרי render)
        const timeoutId = setTimeout(() => {
            Object.values(categoryHeaderRefs.current).forEach(ref => {
                if (ref) observer.observe(ref);
            });
        }, 100);

        return () => {
            clearTimeout(timeoutId);
            observer.disconnect();
        };
    }, [filteredProducts]);

    // Lazy loading observer - טוען עוד מוצרים כשמגיעים לסוף הרשימה
    useEffect(() => {
        if (!loadMoreTriggerRef.current) return;
        
        const loadMoreObserver = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting && !isLoadingMore.current && hasMore) {
                    loadMoreProducts();
                }
            },
            {
                root: null,
                rootMargin: '400px', // מתחיל לטעון 400px לפני שמגיעים לסוף
                threshold: 0.1
            }
        );

        loadMoreObserver.observe(loadMoreTriggerRef.current);

        return () => {
            loadMoreObserver.disconnect();
        };
    }, [hasMore, filteredProducts]);

    const loadMoreProducts = async () => {
        if (isLoadingMore.current || !hasMore || !currentLoadingParams.current) return;

        isLoadingMore.current = true;
        
        try {
            const { restId, categoryIndex, subCategoryIndex } = currentLoadingParams.current;
            const result = await utilsRests.getSupermarketProducts(
                restId,
                categoryIndex,
                subCategoryIndex,
                currentOffsetRef.current, // משתמש ב-ref לערך העדכני
                30
            );

            if (result && result.products) {
                setFilteredProducts(prev => [...prev, ...result.products]);
                const newOffset = currentOffsetRef.current + result.products.length;
                currentOffsetRef.current = newOffset;
                setCurrentOffset(newOffset);
                setHasMore(result.hasMore);
                setTotalProducts(result.totalProducts);
            }
        } catch (error) {
            console.error('Error loading more products:', error);
        } finally {
            isLoadingMore.current = false;
        }
    };

    const loadInitialProducts = async (categoryIndex, subCategoryIndex) => {
        try {
            // Reset offset when loading initial products
            currentOffsetRef.current = 0;
            setCurrentOffset(0);
            
            currentLoadingParams.current = {
                restId: props.restPage._id,
                categoryIndex,
                subCategoryIndex
            };

            const result = await utilsRests.getSupermarketProducts(
                props.restPage._id,
                categoryIndex,
                subCategoryIndex,
                0,
                30
            );

            if (result && result.products) {
                setFilteredProducts(result.products);
                const newOffset = result.products.length;
                currentOffsetRef.current = newOffset;
                setCurrentOffset(newOffset);
                setHasMore(result.hasMore);
                setTotalProducts(result.totalProducts);
            }
        } catch (error) {
            console.error('Error loading initial products:', error);
            setFilteredProducts([]);
        }
    };

    useEffect(() => {
        // לא טוען שום דבר בפתיחה - רק כאשר המשתמש בוחר קטגוריה
        // if (!hasInitialLoaded.current && selectedCategory === null) {
        //     hasInitialLoaded.current = true;
        //     handleCategoryClick(0);
        // }
    }, []);

    useEffect(() => {
        //ה-props כבר נושאים את האמת התלת-ערוצית מ-RestaurantPage.
        //בדיקת שעות הפתיחה שהייתה כאן הוסרה - שעות פתיחה
        //אינן חוסמות הזמנות יותר
        if (!props.doDeliver && !props.doTakeAway) {
            setOnlyPhone(true);
        }

    }, []);
    useEffect(() => {
        return () => {
            if (searchTimeoutRef.current) {
                clearTimeout(searchTimeoutRef.current);
            }
        };
    }, []);

    const handleChange = (newValue) => {
        setValue(newValue);
        scroller.scrollTo(`divBlock_${newValue}`, { smooth: true, offset: -140, duration: 1000 });

    };


    const handleScroll = () => {
        const currentScrollY = window.scrollY;
        let bottomMastPos = "";
        try {
            bottomMastPos = window.document.getElementsByClassName("BottomMast")[0].offsetTop;
        } catch {
            bottomMastPos = 0;
        }
        if (RestMnuRef.current) {
            //בלי גבול עליון, התפריט/חיפוש הקבועים ממשיכים "לגלוש" גם אחרי
            //שהגללנו מעבר לסוף התפריט - וברגע ש-BottomMast (הבאנרים/פוטר
            //בתחתית העמוד) נכנס לתצוגה, הם נשארים fixed מעליו ומכסים אותו.
            //BottomMast "נכנס למסך" בדיוק כש-offsetTop שלו מגיע לתחתית
            //חלון התצוגה הנוכחי (currentScrollY + innerHeight) - לא מספר
            //קבוע, כדי שזה יתאים לכל גובה מסך. הטריגר בפועל מושהה עוד
            //200px אחרי הכניסה, כדי שהמעבר ל-absPos לא יקרה מוקדם מדי
            //ויתחוש קפיצתי. עמוד סופרמרקט בלבד - יש בו infinite scroll עם
            //תוכן שמשתנה, ולכן זה בעיה מורגשת יותר כאן מאשר בתפריט מסעדה
            //רגיל
            const pastBottomMast = bottomMastPos && (currentScrollY + window.innerHeight) > bottomMastPos + 200;
            const withinMenu = currentScrollY > RestMnuRef.current.offsetTop - 70;

            if (withinMenu && !pastBottomMast) {
                setRestMnuFxClass("fixPos");
                setRestMnuSpClass("PaddMeFix");
                setMnuDivsPadd("withPadd");
                setFrozenTop(null);
            } else if (withinMenu && pastBottomMast) {
                //עוברים ל-absolute רק פעם אחת, ברגע המעבר - "קופאים" בדיוק
                //במקום שבו ה-fixed נעצר (currentScrollY + headerHeight),
                //כדי שהמעבר יהיה חלק ובלי קפיצה
                setRestMnuFxClass("absPos");
                setRestMnuSpClass("PaddMeFix");
                setMnuDivsPadd("withPadd");
                setFrozenTop(prev => prev !== null ? prev : currentScrollY + headerHeight);
            } else {
                setRestMnuFxClass("noFix");
                setRestMnuSpClass("");
                setMnuDivsPadd("noPadd");
                setFrozenTop(null);
            }
        }
    };
    const handleCategoryClick = (index) => {
        setValue(index);
        setSubVal({ Division: -1, SubDivision: -1 });
        setSearchTxt("");
        
        // סמן שאנחנו גוללים פרוגרמטית
        isScrollingProgrammatically.current = true;
        
        // גלילה לתחילת RestMnu עם offset של 100px
        if (RestMnuRef.current) {
            const elementPosition = RestMnuRef.current.offsetTop;
            window.scrollTo(0, elementPosition - 50);
        }

        // אחרי 1 שניה, אפשר עדכונים מגלילה רגילה
        setTimeout(() => {
            isScrollingProgrammatically.current = false;
        }, 1000);

        setFilteredProducts([]); // Clear the product list first
        setSelectedCategory(index);
        setSelectedSubCategory(null);
        
        // Load products from server
        loadInitialProducts(index, -1);
    };

    const handleCategoryProductsClick = (categoryIndex) => {
        setSubVal({ Division: categoryIndex, SubDivision: -2 }); // -2 indicates category products
        setSearchTxt("");
        
        // סמן שאנחנו גוללים פרוגרמטית
        isScrollingProgrammatically.current = true;
        
        // גלילה לתחילת RestMnu עם offset של 100px
        if (RestMnuRef.current) {
            const elementPosition = RestMnuRef.current.offsetTop;
            window.scrollTo(0, elementPosition - 50);
        }

        // אחרי 1 שניה, אפשר עדכונים מגלילה רגילה
        setTimeout(() => {
            isScrollingProgrammatically.current = false;
        }, 1000);

        setFilteredProducts([]); // Clear the product list first
        setSelectedCategory(categoryIndex);
        setSelectedSubCategory(-2);
        
        // Load products from server
        loadInitialProducts(categoryIndex, -2);
    };

    const handleSubCategoryClick = (categoryIndex, subCategoryIndex) => {
        setSubVal({ Division: categoryIndex, SubDivision: subCategoryIndex });
        setSearchTxt("");
        
        // סמן שאנחנו גוללים פרוגרמטית
        isScrollingProgrammatically.current = true;
        
        // גלילה לתחילת RestMnu עם offset של 100px
        if (RestMnuRef.current) {
            const elementPosition = RestMnuRef.current.offsetTop;
            window.scrollTo(0, elementPosition - 50);
        }

        // אחרי 1 שניה, אפשר עדכונים מגלילה רגילה
        setTimeout(() => {
            isScrollingProgrammatically.current = false;
        }, 1000);

        setFilteredProducts([]); // Clear the product list first
        setSelectedCategory(categoryIndex);
        setSelectedSubCategory(subCategoryIndex);
        
        // Load products from server
        loadInitialProducts(categoryIndex, subCategoryIndex);
    };
    
    const serachMnuItm = (txtSearch) => {
        // גלילה לתחילת RestMnu
        if (RestMnuRef.current) {
            const elementPosition = RestMnuRef.current.offsetTop;
            window.scrollTo(0, elementPosition - 50);
        }

        if (txtSearch.trim() === "") {
            // אם אין טקסט חיפוש, נציג את קוביות הקטגוריות
            setSelectedCategory(null);
            setSelectedSubCategory(null);
            setFilteredProducts([]);
            return;
        }

        // חיפוש בכל המוצרים - בלי לשנות את הקטגוריה הנבחרת
        const allProducts = props.supermarketMenu.flatMap(category => {
            const categoryLevelProducts = category.categoryProducts || [];
            const subdivisionProducts = category.subDivisons ? category.subDivisons.flatMap(sub => sub.Products || []) : [];
            return [...categoryLevelProducts, ...subdivisionProducts];
        });

        const searchLower = txtSearch.toLowerCase();

        const searchResults = allProducts
            .filter(product =>
                product.prodName && product.prodName.toLowerCase().includes(searchLower)
            )
            .sort((a, b) => {
                const aName = a.prodName.toLowerCase();
                const bName = b.prodName.toLowerCase();

                // 1. מוצרים שמתחילים במילת החיפוש המדויקת
                const aStartsWith = aName.startsWith(searchLower);
                const bStartsWith = bName.startsWith(searchLower);

                if (aStartsWith && !bStartsWith) return -1;
                if (!aStartsWith && bStartsWith) return 1;

                // 2. מוצרים שמילת החיפוש מופיעה בתחילת מילה
                const aWordStart = aName.startsWith(searchLower) || aName.includes(' ' + searchLower);
                const bWordStart = bName.startsWith(searchLower) || bName.includes(' ' + searchLower);

                if (aWordStart && !bWordStart) return -1;
                if (!aWordStart && bWordStart) return 1;

                // 3. לפי המיקום של מילת החיפוש (ככל שיותר מוקדם - יותר טוב)
                const aIndex = aName.indexOf(searchLower);
                const bIndex = bName.indexOf(searchLower);

                if (aIndex !== bIndex) return aIndex - bIndex;

                // 4. לפי סדר אלפביתי
                return aName.localeCompare(bName, 'he');
            });

        setFilteredProducts(searchResults);
    };
    let onlyPhoneOrders = (currP.buissIsOnline != null && currP.buissIsOnline) ? "" : "כרגע, הזמנות טלפונית";

    //מחשב את ה-style עבור התפריט/חיפוש הקבועים לפי restMnuFxClass -
    //fixPos: מוצמד לראש המסך (top=headerHeight, viewport-relative).
    //absPos: קפוא במקום שבו ה-fixed נעצר (top=frozenTop, document-relative)
    //כדי שלא "יקפוץ" בחזרה למיקום הסטטי שלו כשעוברים ל-BottomMast
    const getFixedElementStyle = () => {
        if (restMnuFxClass === "fixPos") return { top: headerHeight };
        if (restMnuFxClass === "absPos" && frozenTop !== null) return { top: frozenTop };
        return undefined;
    };

    return (
        <div className="RestMnu RestSuperMenu" ref={RestMnuRef}>

            {/* טאבים ימין + שורת חיפוש בדסקטופ - שני אלמנטים נפרדים, כל אחד
                עם position:fixed עצמאי משלו. קלאסים ייעודיים ל-RestSuperMenu
                בלבד (superMnuRight/superSearchOnMnuDesktop, לא rstMnuRight/
                serachOnMnuDesktop המשותפים עם RestMnu.js) כדי שתיקונים כאן
                לא ישפיעו על עמוד המסעדה הרגיל. שניהם נשלטים ע"י אותו
                restMnuFxClass כדי שיהפכו fixed באותו רגע בדיוק ולהישאר
                זה-לצד-זה */}
            {(!mobiOrNot) ? (
                <>
                    <div className={`rstMnuRight superMnuRight ${restMnuFxClass}`}
                        style={getFixedElementStyle()}>

                        <div className={"fxPosWrap"} style={{ maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' }}>
                            <Box sx={{ bgcolor: "white", direction: "rtl" }}>
                                <MenuList orientation={"vertical"}
                                    aria-label="תפריט">
                                    {
                                        props.supermarketMenu.map((item, index) => {
                                            if (!item.hideFromMenu && myFunctions.checkMnuItemDisplay(item.divTiming)) {

                                                return (
                                                    <div key={index}>
                                                        {/* קטגוריה ראשית */}
                                                        <MenuItem
                                                            onClick={() => handleCategoryClick(index)}
                                                            className={`tabClass ${(selectedCategory === index) ? "selcedMnuIt" : ""}`}
                                                            style={{
                                                                color: selectedCategory === index ? "var(--turqiText)" : "black",
                                                            }}
                                                        >
                                                            {item.Division}
                                                        </MenuItem>

                                                        {/* תתי-קטגוריות */}
                                                        {selectedCategory === index && item.subDivisons && (
                                                            <div className="subCategories">
                                                                {/* Category-level products */}
                                                                {item.categoryProducts && item.categoryProducts.length > 0 && 
                                                                 item.subDivisons && item.subDivisons.length > 0 && (
                                                                    <MenuItem
                                                                        onClick={() => handleCategoryProductsClick(index)}
                                                                        className={`subCategoryItem ${(selectedSubCategory === -2) ? "selectedSubCategory" : ""}`}
                                                                        style={{
                                                                            paddingLeft: "20px",
                                                                            color: selectedSubCategory === -2 ? "var(--turqiText)" : "gray",
                                                                        }}
                                                                    >
                                                                        ללא מחלקה
                                                                    </MenuItem>
                                                                )}
                                                                {item.subDivisons.map((subItem, subIndex) => (
                                                                    <MenuItem
                                                                        key={subIndex}
                                                                        onClick={() => handleSubCategoryClick(index, subIndex)}
                                                                        className={`subCategoryItem ${(selectedSubCategory === subIndex) ? "selectedSubCategory" : ""}`}
                                                                        style={{
                                                                            paddingLeft: "20px",
                                                                            color: selectedSubCategory === subIndex ? "var(--turqiText)" : "gray",
                                                                        }}
                                                                    >
                                                                        {subItem.DivName}
                                                                    </MenuItem>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>

                                                )
                                            }
                                        })
                                    }
                                </MenuList>
                            </Box>

                        </div>
                    </div>

                    <div
                        ref={searchBarRef}
                        className={`serachOnMnu superSearchOnMnuDesktop ${restMnuFxClass}`}
                        style={getFixedElementStyle()}>
                        {searchTxt !== "" ? (
                            <div onClick={() => {
                                setSearchTxt("");
                                serachMnuItm("");
                            }}>
                                <HighlightOffIcon className="clearSrch" />
                            </div>
                        ) : (
                            ""
                        )}
                        <input
                            type={"text"}
                            placeholder={`חפש בתפריט של ${props.nameBuis}`}
                            value={searchTxt}
                            onChange={(e) => {
                                const newValue = e.target.value;
                                setSearchTxt(newValue);

                                if (searchTimeoutRef.current) {
                                    clearTimeout(searchTimeoutRef.current);
                                }

                                searchTimeoutRef.current = setTimeout(() => {
                                    serachMnuItm(newValue);
                                }, 300);
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    serachMnuItm(searchTxt);
                                }
                            }}
                        />
                        <img id="searchBtn" src="/PermanentImages/searchIc.gif" alt="חיפוש בעסק"
                            onClick={() => serachMnuItm(searchTxt)} />
                    </div>
                </>
            ) : (
                <div className={`tabsHeadPlace ${restMnuFxClass}`}>
                    <div className={"fxPosWrap"}>
                        <Box sx={{ bgcolor: 'white', direction: 'rtl' }}>
                            {(restMnuFxClass == "fixPos") ?
                                <>
                                    <h2 className={"headOnPFix bold SecondFontRegular big"}>
                                        {currP.buissName}
                                    </h2>
                                    <p className="onPhonePFix">{onlyPhoneOrders}</p>
                                </>
                                : ""}

                            {/* הטאבים - תמיד מוצגים */}
                            <Tabs
                                value={value}
                                variant="scrollable"
                                aria-label="תפריט"
                            >
                                {
                                    props.supermarketMenu.map((item, index) => {
                                        if (!item.hideFromMenu && myFunctions.checkMnuItemDisplay(item.divTiming)) {
                                            return (
                                                <Tab
                                                    key={`category_${index}`}
                                                    onClick={() => handleCategoryClick(index)}
                                                    className={"tabClass"}
                                                    style={{ color: "black" }}
                                                    label={item.Division}
                                                />
                                            );
                                        }
                                    })
                                }
                            </Tabs>

                            {selectedCategory !== null && props.supermarketMenu[selectedCategory].subDivisons && (
                                <Box sx={{ bgcolor: 'white', direction: 'rtl' }}>
                                    <Tabs
                                        value={(() => {
                                            const hasCategoryProducts = props.supermarketMenu[selectedCategory].categoryProducts && 
                                                                       props.supermarketMenu[selectedCategory].categoryProducts.length > 0;
                                            
                                            if (selectedSubCategory === -2) {
                                                // מוצרים נמצא בעמדה 0
                                                return 0;
                                            } else if (selectedSubCategory !== null && selectedSubCategory > -1) {
                                                // תתי קטגוריות מתחילים מעמדה 1 (אם יש מוצרים) או 0 (אם אין)
                                                return hasCategoryProducts ? selectedSubCategory + 1 : selectedSubCategory;
                                            }
                                            return false;
                                        })()}
                                        variant="scrollable"
                                        aria-label="תתי קטגוריות"
                                    >
                                        {/* Tab for category-level products */}
                                        {props.supermarketMenu[selectedCategory].categoryProducts && 
                                         props.supermarketMenu[selectedCategory].categoryProducts.length > 0 &&
                                         props.supermarketMenu[selectedCategory].subDivisons &&
                                         props.supermarketMenu[selectedCategory].subDivisons.length > 0 && (
                                            <Tab
                                                key={`category_products_${selectedCategory}`}
                                                value={0}
                                                onClick={() => handleCategoryProductsClick(selectedCategory)}
                                                className={"tabClass"}
                                                style={{ color: "gray" }}
                                                label="ללא מחלקה"
                                            />
                                        )}
                                        {
                                            props.supermarketMenu[selectedCategory].subDivisons.map((subItem, subIndex) => {
                                                const hasCategoryProducts = props.supermarketMenu[selectedCategory].categoryProducts && 
                                                                           props.supermarketMenu[selectedCategory].categoryProducts.length > 0;
                                                const tabValue = hasCategoryProducts ? subIndex + 1 : subIndex;
                                                
                                                return (
                                                    <Tab
                                                        key={`subcategory_${selectedCategory}_${subIndex}`}
                                                        value={tabValue}
                                                        onClick={() => handleSubCategoryClick(selectedCategory, subIndex)}
                                                        className={"tabClass"}
                                                        style={{ color: "gray" }}
                                                        label={subItem.DivName}
                                                    />
                                                );
                                            })
                                        }
                                    </Tabs>
                                </Box>
                            )}
                        </Box>
                        {/* שורת חיפוש - תמיד תופיע */}
                        <div className={"serachOnMnu"}>
                            {searchTxt !== "" ? (
                                <div onClick={() => serachMnuItm("")}>
                                    <HighlightOffIcon className="clearSrch" />
                                </div>
                            ) : (
                                ""
                            )}
                            <input
                                type={"text"}
                                placeholder={`חפש בתפריט של ${props.nameBuis}`}
                                value={searchTxt}
                                onChange={(e) => {
                                    const newValue = e.target.value;
                                    setSearchTxt(newValue);

                                    // בטל טיימר קודם
                                    if (searchTimeoutRef.current) {
                                        clearTimeout(searchTimeoutRef.current);
                                    }

                                    // החיפוש יתבצע רק 300ms אחרי שהמשתמש מפסיק להקליד
                                    searchTimeoutRef.current = setTimeout(() => {
                                        serachMnuItm(newValue);
                                    }, 300);
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        serachMnuItm(searchTxt);
                                    }
                                }}
                            />
                            <img id="searchBtn" src="/PermanentImages/searchIc.gif" alt="חיפוש בעסק"
                                onClick={() => serachMnuItm(searchTxt)} />
                        </div>
                    </div>
                </div>

            )
            }

            {/* שמאל בדסקטופ */}
            {
                (!mobiOrNot) ? <div className={"rstMnuLeft"}>
                    <div className={"rstMnuLeftIn fxPosWrap"}>
                        <div style={{ overflow: "hidden" }}>
                            <div className={"bold"}>פרטי העסק:</div>
                            <br />
                            <PhoneLink phone={props.restPage.buissPhone} className={"overFlHid"}>
                                <div className={"phoneLine"}>
                                    <div className="clickPhoneBtn">{getPhoneDisplay(props.restPage.buissPhone)}</div>
                                </div>
                            </PhoneLink>
                            {(props.restPage.buissAddress) ? <AddressLine address={props.restPage.buissAddress} /> : ""}
                            <DayOpeningHours item={props.restPage} />
                            {props.delTiming}
                            <BuisRating rating={props.restPage.buissRating} restId={props.restPage._id} />

                        </div>
                        <br />
                        <div className={"bold pointing"} onClick={() => props.showMoreDet()}>
                            <span>עוד פרטים</span>
                        </div>

                        <div className={"detailsLine moreDetBtn pointing"}>
                            {/* <div className={"bold"} onClick={() => props.setDispOnlyDelivery()}>
                                <span>{(props.dispOnlyDelivery) ? "הצג תפריט מלא" : "הצג תפריט משלוחים"} </span>
                            </div> */}
                        </div>
                    </div>
                </div> : ""
            }
            {/* תצוגת מוצרים */}
            <div className={`rstMnuWrap ${restMnuSpClass}`}>

                <div className="products">
                    {searchTxt !== "" ? (
                        <div className="search-results-header spaceRightLongi">
                            <h2>{`תוצאות חיפוש עבור "${searchTxt}" (${filteredProducts.length} מוצרים)`}</h2>
                        </div>
                    ) : (
                        <>
                            {/* {selectedSubCategory !== null && selectedSubCategory !== -2 && selectedCategory !== null && (
                                <div className="subcategory-header spaceRightLongi">
                                    <h2>{`${props.supermarketMenu[selectedCategory].Division} / ${props.supermarketMenu[selectedCategory].subDivisons[selectedSubCategory]?.DivName}`}</h2>
                                </div>
                            )} */}
                            {/* {selectedSubCategory === -2 && selectedCategory !== null && (
                                <div className="subcategory-header spaceRightLongi">
                                    <h2>{`${props.supermarketMenu[selectedCategory].Division} / מוצרים`}</h2>
                                </div>
                            )} */}
                            {/* {selectedCategory !== null && selectedSubCategory === null && (
                                <div className="category-header spaceRightLongi">
                                    <h2>{`${props.supermarketMenu[selectedCategory].Division}`}</h2>
                                </div>
                            )} */}
                        </>
                    )}
                    {selectedCategory === null && searchTxt === "" ? (
                        // תצוגת גריד קטגוריות כאשר לא נבחרה קטגוריה
                        <ul className="categories-grid">
                            {props.supermarketMenu.map((category, index) => {
                                if (!category.hideFromMenu && myFunctions.checkMnuItemDisplay(category.divTiming)) {
                                    return (
                                        <li
                                            key={index}
                                            className="category-card"
                                            onClick={() => handleCategoryClick(index)}
                                        >
                                            <div className="category-card-image">
                                                <img src={ConnUrls.media(category.categuryImageUrl)} alt={category.Division} />
                                            </div>
                                            <h3 className="category-card-title">{category.Division}</h3>
                                        </li>
                                    );
                                }
                                return null;
                            })}
                        </ul>
                    ) : filteredProducts.length > 0 ? (
                        filteredProducts.map((product, productIndex) => {
                            // Check if this is a category header
                            if (product.isHeader) {
                                return (
                                    <div 
                                        key={`header_${productIndex}`} 
                                        ref={el => categoryHeaderRefs.current[product.categoryName] = el}
                                        data-category-index={product.categoryIndex}
                                        data-sub-category-index={product.subCategoryIndex}
                                        className="category-section-header" 
                                        style={{
                                            width: '100%',
                                            padding: '15px 20px',
                                            fontSize: '20px',
                                            fontWeight: 'bold',
                                            color: '#333',
                                            borderBottom: '2px solid #ddd',
                                            marginTop: productIndex === 0 ? '0' : '20px',
                                            marginBottom: '10px',
                                            textAlign: 'right',
                                            clear: 'both'
                                        }}>
                                        {product.categoryName}
                                    </div>
                                );
                            }
                            
                            // Regular product display
                            return (
                                <div key={productIndex} className="productItem">
                                    {mobiOrNot ? (
                                        <ProductItem
                                            key={product._id || `product_${productIndex}`}
                                            isMarket={true}
                                            divitm={product}
                                            itemId={`${selectedCategory}_${selectedSubCategory}_${productIndex}`}
                                            doDeliver={props.doDeliver}
                                            doTakeAway={props.doTakeAway}
                                            onlyPhone={onlyPhone}
                                            myClass={(!product.inStock) ? "outOfStock smallProdMarket" : "smallProdMarket"}
                                            smallMarketCss={"smallProdMarket"}
                                        />
                                    ) : (
                                        <ProductItemDeskTop
                                            key={product._id || `product_${productIndex}`}
                                            isMarket={true}
                                            divitm={product}
                                            itemId={`${selectedCategory}_${selectedSubCategory}_${productIndex}`}
                                            doDeliver={props.doDeliver}
                                            doTakeAway={props.doTakeAway}
                                            onlyPhone={onlyPhone}
                                            myClass={(!product.inStock) ? "outOfStock" : ""}
                                        />
                                    )}
                                </div>
                            );
                        })
                    ) : (
                        <div className="noProducts">{searchTxt !== "" ? `לא נמצאו תוצאות עבור "${searchTxt}"` : ""}</div>
                    )}                    
                    {/* אלמנט טעינה - מפעיל טעינת מוצרים נוספים */}
                    {filteredProducts.length > 0 && hasMore && (
                        <div 
                            ref={loadMoreTriggerRef}
                            style={{
                                width: '100%',
                                padding: '20px',
                                textAlign: 'center',
                                color: '#999'
                            }}
                        >
                            טוען מוצרים נוספים...
                        </div>
                    )}                </div>
            </div>
        </div >
    );
};

export default RestSuperMenu;